import React, { useState, useEffect } from "react";
import { getBlogs } from "../../services/firebase";
import { BlogType } from "../../types/blog";
import {
  formatToEasternTime,
  formatToET,
} from "../../components/utils/formatToET";
import { Link, useNavigate } from "react-router-dom";
import Markdown from "react-markdown";
import remarkGfm from 'remark-gfm';

const LatestBlogs: React.FC = () => {
  const [blogs, setBlogs] = useState<BlogType[]>([]);
  const navigate = useNavigate();
  useEffect(() => {
    // Fetching products and storing in desc order to show articles created at top of grid
    (async () => {
      try {
        const blogList = await getBlogs(4);
        const sortedBlogs = blogList.sort(
          (a: BlogType, b: BlogType) =>
            new Date(b.dateTimeInEasternTime).getTime() -
            new Date(a.dateTimeInEasternTime).getTime()
        );
        setBlogs(sortedBlogs);
      } catch (err) {
        console.error("Failed to fetch products:", err);
      }
    })();
  }, []);

  const handleNavigate = (slug: string, categoryId: number) => {
    navigate(`/articles/${slug}`);
  };

  if (blogs.length === 0) return null;
  return (
    <section className="latestUpdate">
      <div className="wrapper">
        <div className="sectionHeading">
          <strong>Latest from fl</strong>
          <a href={`/articles`} className="moreLink">View All</a>
        </div>
        <ul>
          {blogs.map((blog: BlogType) => (
            <li
              onClick={() => handleNavigate(blog.slug, blog.blogCategoryId)}
              key={blog.id}
            >
              <div className="leftPic">
                <img
                  src={
                    blog.image
                      ? blog.image
                      : "https://dummyimage.com/300x200/cccccc/000000&text=Fantasy Loser"
                  }
                  alt={blog.title}
                />
              </div>
              <div className="rightContentBlk">
                <div className="contentHeading">{blog.title}</div>
                <div className="contentDesc"><Markdown remarkPlugins={[remarkGfm]}>{blog.excerpt}</Markdown></div>
                {/* <Link to={`articles/${blog.slug}`} key={blog.id} className="readMore">Read More</Link> */}
                <div className="userBlkWrap">
                  <div className="userPic">
                    <img src={blog.thumbnail ? blog.thumbnail : ""} alt="" />
                  </div>
                  <div className="userCont">
                    <div className="userHeading">{blog.author}</div>
                    <div className="updatedOn">
                      {formatToEasternTime(blog.dateTimeInEasternTime) ??
                        formatToET(blog.createdAt)}
                    </div>
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default LatestBlogs;
